import { render } from "./SnackbarAlert.vue?vue&type=template&id=034a6a3c&ts=true"
import script from "./SnackbarAlert.vue?vue&type=script&lang=ts"
export * from "./SnackbarAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__